export class VisualEvent {

  constructor(public id: string, public newValue?: any, public source?: any) {
  }
}
